import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animated } from 'react-spring';
import Img from 'gatsby-image';

import ProductLink from './ProductLink';
import CurrencyFormat from './CurrencyFormat';
import DummyImage from './DummyImage';

const Container = styled(animated.div)`
  .card {
    border: none;
    box-shadow: none;
    background: transparent;
  }
  .card-content {
    padding: 0.75rem 0.5rem;
  }
  .image.is-4by5 {
    padding-top: 0;
  }
  .gatsby-image-wrapper {
    border-radius: 10px;
  }
  .title {
    color: ${(props) => props.theme.primaryColor} !important;
    padding-top: 0.5rem;
  }
  p {
    font-size: ${(props) => props.theme.fontSizeMedium}px !important;
  }
  .content {
    flex: 1;
  }
`;

const Image = styled(Img)`
  object-fit: cover;
`;

const ProductItem = ({ item, styles, small }) => {
  const variant = item.otherVariants[0];

  return (
    <Container className={`column ${small ? 'is-4' : 'is-3'}`} style={styles}>
      <div className="card">
        <ProductLink item={item}>
          <div className="card-image">
            {variant && variant.featuredImage ? (
              <Image
                fluid={{
                  ...variant.featuredImage.asset.fluid,
                  aspectRatio: 1,
                }}
              />
            ) : (
              <DummyImage />
            )}
          </div>
        </ProductLink>
        <div className="card-content">
          <div className="media">
            <div className="has-text-centered content">
              <p className="subtitle has-text-black">
                <ProductLink item={item} />
              </p>
              <p className="title is-family-secondary">
                <CurrencyFormat pricing={variant.pricing} isDiscount />
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

ProductItem.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default ProductItem;
